import { render, staticRenderFns } from "./Invitados.vue?vue&type=template&id=1f88940a&scoped=true&lang=pug&"
import script from "./Invitados.vue?vue&type=script&lang=js&"
export * from "./Invitados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f88940a",
  null
  
)

export default component.exports